/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref: FragmentReference;
declare export opaque type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$fragmentType: WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref;
export type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData = {|
  +getLonewolfPersonalLeaderboardData: ?{|
    +data: ?{|
      +leaderboard: ?$ReadOnlyArray<?{|
        +name: ?string,
        +points: ?number,
        +position: ?string,
      |}>,
      +total_page: ?number,
    |}
  |},
  +$refType: WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref,
|};
export type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$data = WMMobileLeaderboard_getLonewolfPersonalLeaderboardData;
export type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$key = {
  +$data?: WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$data,
  +$fragmentRefs: WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "WMMobileLeaderboard_getLonewolfPersonalLeaderboardData",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "event_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "guest_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "quarter_id",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "page_number",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search_val",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getLonewolfPersonalLeaderboardData",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "event_token",
          "variableName": "event_token"
        },
        {
          "kind": "Variable",
          "name": "guest_token",
          "variableName": "guest_token"
        },
        {
          "kind": "Variable",
          "name": "page_number",
          "variableName": "page_number"
        },
        {
          "kind": "Variable",
          "name": "quarter_id",
          "variableName": "quarter_id"
        },
        {
          "kind": "Variable",
          "name": "search_val",
          "variableName": "search_val"
        }
      ],
      "concreteType": "lonewolfPersonalLeaderboardDataType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "lonewolfPersonalLeaderboardResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "leaderboard",
              "storageKey": null,
              "args": null,
              "concreteType": "lonewolfPositionsType",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "points",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "total_page",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f2a598c5b17ce457cd9424a07c9c6a03';
module.exports = node;
